/** True when crash participated in validation/merge (has merge_date). */
export function hasMergeDate(row) {
  const mergeDate = row?.merge_date ?? row?.crash?.merge_date;
  return mergeDate != null && mergeDate !== '';
}

/**
 * Validated master has empty match_id; merge satellites point at the master id.
 * Prefer explicit match_id from API; when missing on Merged dataset, treat as master.
 */
export function isValidatedMasterRow(row) {
  const matchId = row?.match_id ?? row?.crash?.match_id;
  if (matchId == null) return true;
  return String(matchId).trim() === '';
}

/** SvgCustomIcon name for basic org 1|2|3 (Police / Healthcare / Insurance). */
export function getBasicOrganizationIconName(basicOrganization) {
  const basic = Number(basicOrganization);
  if (basic === 1) return 'police';
  if (basic === 2) return 'healthCrossOutline';
  if (basic === 3) return 'insurance';
  return null;
}

export function splitCrashListRowsByValidation(rows) {
  const pendingRows = [];
  const validatedRows = [];
  rows.forEach((row) => {
    if (hasMergeDate(row)) {
      validatedRows.push(row);
      return;
    }
    pendingRows.push(row);
  });
  return { pendingRows, validatedRows };
}
